export default __webpack_public_path__ + "static/media/plus-icon.834c3dc5.svg";